import Vue from 'vue'
import Vuetify from 'vuetify'
import VueObserveVisibility from 'vue-observe-visibility'

Vue.use(VueObserveVisibility)
Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#112244',
        secondary: '#E8D121',
        accent: '#ffb405',
        mint: '#90E8E3',
        background: '#FFFEFC',
        surface: '#FFFFFF',
        success: '#4CAF50',
        warning: '#FFC745',
        error: '#F95623',
        info: '#2196F3'
      }
    }
  }
})
